var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "35 125 341.88 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    id: "path26"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,377.95333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(107.0519,94.264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 8.801 h -3.539 v 2.751 H 6.58 V 8.801 H 3.041 V 0 Z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14",
    transform: "translate(124.6885,94.264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -8.173 v 11.552 h 8.06 V 8.913 H -5.132 V 7.256 h 4.553 V 4.618 H -5.132 V 2.639 H 0 Z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(132.8178,94.264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 11.552 H 3.041 V 7.256 h 4.263 v 4.296 h 3.041 V 0 H 7.304 V 4.618 H 3.041 V 0 Z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24",
    clipPath: "url(#clipPath28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(156.922,98.8656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-2.8 -1.754,-4.843 -5.004,-4.843 -3.282,0 -5.019,2.043 -5.019,4.843 v 6.95 h 3.041 v -6.999 c 0,-1.206 0.434,-2.075 1.978,-2.075 1.529,0 1.963,0.869 1.963,2.075 V 6.95 H 0 Z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(163.4414,101.4716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -7.208 H -2.783 V 4.344 H 0.483 L 4.746,-2.333 V 4.344 H 7.53 V -7.208 H 4.601 Z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(174.064,100.1041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,3.411 2.51,5.952 5.904,5.952 8.8,5.952 10.94,4.28 11.744,1.69 H 8.14 C 7.851,2.574 6.998,3.234 5.824,3.234 4.327,3.234 3.121,2.188 3.121,-0.08 c 0,-1.931 0.949,-3.427 3.041,-3.427 1.319,0 2.139,0.74 2.477,1.705 H 5.856 v 2.397 h 6.033 C 12.13,-3.217 9.83,-6.082 6.001,-6.082 2.638,-6.082 0,-3.604 0,0",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(192.0065,98.8011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 2.445 L 1.239,3.668 Z M 3.234,-2.397 H -0.82 l -0.724,-2.14 h -3.074 l 4.28,11.552 H 2.993 L 7.224,-4.537 H 3.942 Z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(209.4996,94.264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 8.801 h -3.539 v 2.751 H 6.58 V 8.801 H 3.041 V 0 Z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 221.151,108.309 h 5.615 v -1.77 h -5.615 z m 7.803,-9.443 c 0,-2.8 -1.754,-4.843 -5.003,-4.843 -3.282,0 -5.02,2.043 -5.02,4.843 v 6.95 h 3.041 v -6.999 c 0,-1.207 0.434,-2.075 1.979,-2.075 1.528,0 1.962,0.868 1.962,2.075 v 6.999 h 3.041 z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(235.7954,98.8011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 2.445 L 1.239,3.668 Z M 3.234,-2.397 H -0.82 l -0.724,-2.14 h -3.074 l 4.28,11.552 H 2.993 L 7.224,-4.537 H 3.942 Z",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(253.2228,100.0563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,1.818 -1.013,3.282 -2.832,3.282 -1.817,0 -2.831,-1.464 -2.831,-3.282 0,-1.819 1.014,-3.315 2.831,-3.315 C -1.013,-3.315 0,-1.819 0,0 m -8.784,0 c 0,3.507 2.622,6 5.952,6 3.347,0 5.969,-2.493 5.969,-6 0,-3.507 -2.622,-6.034 -5.969,-6.034 -3.33,0 -5.952,2.527 -5.952,6.034",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(80.4752,154.8278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 3.152,-0.998 4.686,-3.131 4.854,-6.66 4.86,-7.029 5.157,-7.327 5.528,-7.327 h 5.669 c 0.372,0 0.663,0.3 0.667,0.671 C 11.667,-0.577 8.778,3.846 3.713,6.06 Z",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(39.8943,111.9424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -3.126,1.279 -3.55,3.87 -3.578,7.044 V 7.031 c 0,0.374 -0.294,0.678 -0.669,0.678 h -5.669 c -0.373,0 -0.667,-0.301 -0.67,-0.674 0.007,-1.978 0.115,-4.978 1.579,-7.837 1.291,-2.522 3.238,-4.153 5.329,-5.201 z",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(56.2748,185.5333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 2.169,-1.576 C 2.482,-1.803 2.64,-2.291 2.521,-2.659 L 1.692,-5.208 C 1.573,-5.577 1.731,-5.692 2.044,-5.464 l 2.169,1.576 c 0.313,0.227 0.826,0.227 1.139,0 l 2.169,-1.576 c 0.313,-0.228 0.471,-0.113 0.352,0.256 l -0.829,2.549 c -0.12,0.368 0.039,0.856 0.352,1.083 L 9.565,0 C 9.878,0.228 9.818,0.414 9.43,0.414 H 6.75 c -0.387,0 -0.802,0.301 -0.922,0.669 L 5,3.633 c -0.12,0.368 -0.315,0.368 -0.435,0 L 3.736,1.083 C 3.617,0.715 3.202,0.414 2.815,0.414 H 0.134 C -0.253,0.414 -0.313,0.228 0,0",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(43.1305,182.5156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 1.444,-1.049 C 1.757,-1.276 1.915,-1.764 1.796,-2.132 L 1.244,-3.829 c -0.12,-0.368 0.039,-0.483 0.352,-0.256 l 1.444,1.049 c 0.313,0.228 0.825,0.228 1.138,0 l 1.444,-1.049 c 0.313,-0.227 0.471,-0.112 0.352,0.256 l -0.552,1.697 c -0.119,0.368 0.039,0.856 0.352,1.083 L 7.218,0 C 7.531,0.228 7.47,0.414 7.084,0.414 H 5.299 c -0.387,0 -0.802,0.301 -0.921,0.669 L 3.826,2.78 C 3.707,3.148 3.511,3.148 3.392,2.78 L 2.84,1.083 C 2.72,0.715 2.306,0.414 1.919,0.414 H 0.134 C -0.253,0.414 -0.313,0.228 0,0",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    transform: "translate(71.7661,182.5156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 1.444,-1.049 C 1.757,-1.276 1.915,-1.764 1.796,-2.132 L 1.244,-3.829 c -0.12,-0.368 0.039,-0.483 0.352,-0.256 l 1.443,1.049 c 0.314,0.228 0.826,0.228 1.139,0 l 1.444,-1.049 c 0.313,-0.227 0.471,-0.112 0.352,0.256 l -0.552,1.697 c -0.119,0.368 0.039,0.856 0.352,1.083 L 7.218,0 C 7.531,0.228 7.47,0.414 7.083,0.414 H 5.299 c -0.387,0 -0.802,0.301 -0.921,0.669 L 3.826,2.78 C 3.707,3.148 3.511,3.148 3.391,2.78 L 2.84,1.083 C 2.72,0.715 2.306,0.414 1.919,0.414 H 0.134 C -0.253,0.414 -0.313,0.228 0,0",
    style: {
      fill: "#7c7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g80",
    transform: "translate(67.013,156.1747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 4.172,6.809 C -2.708,7.238 -9.675,7.181 -16.436,6.638 l 4.131,-6.744 C -8.238,0.111 -4.113,0.145 0,0",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84",
    transform: "translate(93.6582,121.0991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.156,4.213 -1.799,7.881 -4.75,10.609 -2.957,2.732 -7.093,4.44 -12.295,5.078 -2.235,0.274 -4.546,0.437 -6.844,0.531 l -1.787,-2.916 2.53,-4.13 c 1.78,-0.091 3.548,-0.23 5.248,-0.439 4.841,-0.593 10.662,-2.635 10.897,-8.992 0.099,-2.667 -0.948,-5.848 -5.536,-7.885 l 3.67,-5.991 c 1.647,0.818 3.087,1.796 4.308,2.935 C -1.414,-8.266 0.163,-4.394 0,0",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(31.8757,135.8312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.951,-2.599 7.073,-4.224 12.253,-4.83 2.333,-0.272 4.749,-0.429 7.146,-0.517 l 2.399,3.917 -1.882,3.073 C 17.599,1.723 15.277,1.87 13.066,2.129 8.231,2.694 2.419,4.614 2.189,10.549 2.104,12.718 2.849,14.47 4.464,15.906 5.694,17 7.423,17.884 9.567,18.535 L 5.815,24.659 C 3.442,23.76 1.433,22.586 -0.191,21.142 -3.38,18.307 -4.978,14.55 -4.812,10.277 -4.653,6.187 -2.989,2.633 0,0",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92",
    transform: "translate(80.9505,174.5607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -20.122,-32.902 -40.263,0 h -8.89 l 23.877,-39.005 h 10.307 L 8.888,0 Z",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96",
    transform: "translate(60.8283,127.1434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 9.982,-16.294 c -6.592,-0.622 -13.414,-0.728 -20.16,-0.32 z m -20.16,-32.881 5.866,9.549 c 4.023,-0.353 8.089,-0.532 12.142,-0.532 5.469,0 10.912,0.322 16.182,0.962 l 6.101,-9.979 h 8.884 L 5.153,6.103 H -5.153 l -23.911,-38.984 z",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100",
    transform: "translate(128.5401,117.3916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -14.607,0 -23.981,7.733 -24.996,20.153 h 14.919 c 0.157,-5.311 3.672,-8.671 9.765,-8.671 5.077,0 8.436,1.954 8.436,5.468 0,2.422 -2.422,4.219 -5.702,4.843 l -10.234,1.954 c -8.983,1.718 -14.919,6.952 -14.919,16.013 0,10.467 9.217,17.809 21.793,17.809 13.358,0 22.966,-7.654 23.825,-19.762 H 7.968 c -0.391,5.077 -3.828,8.358 -8.749,8.358 -4.374,0 -7.031,-2.343 -7.031,-5.39 0,-2.499 2.5,-3.984 5.469,-4.53 L 8.514,34.136 C 18.513,32.182 23.824,27.261 23.824,19.138 23.824,7.577 14.607,0 0,0",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(187.6723,118.1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -16.091 l -19.841,56.085 h 16.013 L -7.577,17.263 5.155,56.085 h 14.842 z",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g108",
    transform: "translate(221.3395,140.2003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 11.873 L 6.015,17.81 Z M 15.701,-11.639 H -3.984 l -3.515,-10.389 h -14.92 L -1.64,34.058 H 14.529 L 35.073,-22.028 H 19.138 Z",
    style: {
      fill: "#201c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81274674110795ae3fdaff1fc649f07c.svg";
export { ForwardRef as ReactComponent };